import React, { useEffect, useState } from "react";
import { USER_PLUS_ICON, CALENDER_ICON } from "assets/constants/Icons";
import { TYPE_SUCCESS, INTERVAL } from "assets/constants/Constants";
import MaterialTable from "material-table";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { getReferralList, sendInviteCall, createAuditLogCall} from "lib/axiosUtils";
import "./user-style.css";
import moment from 'moment';
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';

const ReferralPage = () => {

    const [referralList, setReferralList] = useState([]);
    const userDetail = JSON.parse(localStorage.getItem("userData"));
    const [isLoading, setIsLoading] = useState(true);
    const [emailsIds, setEmailIds] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchReferralList = async () => {
            try {
                const data = await getReferralList({}, {}, userDetail.referral_code);
                setReferralList(data.data.result);
                setIsLoading(false);
            }
            catch (error) {
                setIsLoading(false);
                console.log("error while fetching data", error);
            }
        }
        fetchReferralList();
    }, [userDetail.referral_code]);

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return re.test(email);
    };

    const sendInvite = async () => {
        setError("");
    
        // Split by comma
        let emails = emailsIds
          .split(",")
          .map((e) => e.trim())
          .filter((e) => e.length > 0);
    
        if (emails.length === 0) {
          setError("Please enter at least one email.");
          return;
        }
    
        // Validate each email
        const invalidEmails = emails.filter((e) => !validateEmail(e));
    
        if (invalidEmails.length > 0) {
          setError(`Invalid email(s): ${invalidEmails.join(", ")}`);
          return;
        }

        const inviteParams = {
            userEmails : emails,
            userReferralCode : userDetail.referral_code,
            userName: `${userDetail.first_name} ${userDetail.last_name}`
        }

        try {
            const response = await sendInviteCall({}, inviteParams);
            if (response.statusCode === 200) {
                const referralParams = {
                    moduleName: "Referral Module",
                    userID: userDetail._id,
                    logText: `Referral Invite Sent to : ${emails}`,
                };
                await createAuditLogCall({}, referralParams);
                ShowToast(`Invite Sent successfully`, TYPE_SUCCESS, INTERVAL, "/referral-page");
            }
        }
        catch (error) {
            console.log(`Error occurred while sending Invite`, error);
        }
        
        setEmailIds("");
      };

    const mytheme = createTheme({});
    return (<>
        {
            isLoading === true ? (
                <Spinner />
            ) :
                (
                    <div className="main-content">
                        <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
                            <div className="col-md-10 sm_device"><i className={`${USER_PLUS_ICON}`}></i> Referral Page</div>
                            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
                        </div>
                        <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
                        <div className="list-wrapper">
                            <div className="referral-wrapper">
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    Enter comma seprated email ids:
                                </div>
                                <div className="referral-email-box">
                                    <input style={{ width: "100%", padding: 8 }} value={emailsIds} onChange={(e) => setEmailIds(e.target.value)} placeholder="abc@example.com, xyz@gmail.com" /> 
                                </div>
                                {error && (
                                    <div style={{ color: "red", marginTop: 6, fontSize: 14 }}>
                                        {error}
                                    </div>
                                )}
                                <button className="brand-button ml-5" onClick={sendInvite }>Send Invite</button>
                            </div>
                            <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
                                {
                                    referralList && referralList.length > 0 ? (
                                        <ThemeProvider theme={mytheme}>
                                            <MaterialTable
                                                columns={[
                                                    {
                                                        title: "Name", field: "name",
                                                        cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                                    },
                                                    {
                                                        title: "Email ID", field: "email_id",
                                                        cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                                    },
                                                    {
                                                        title: "Referral Credited", field: "referral_credited",
                                                        cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 },
                                                        sorting: false
                                                    },
                                                    {
                                                        title: "Created Date", field: "created_date",
                                                        cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                                        sorting: false
                                                    },


                                                ].filter(Boolean)}
                                                data={
                                                    referralList.map((item) => {
                                                        return (
                                                            {
                                                                name: `${item.first_name} ${item.last_name}`,
                                                                email_id: item.email_id,
                                                                created_date: new Date(item.created_date_time).toLocaleDateString('en-IN', {
                                                                    day: '2-digit',
                                                                    month: '2-digit',
                                                                    year: 'numeric',
                                                                    hour: '2-digit',
                                                                    minute: '2-digit',
                                                                    second: '2-digit',
                                                                    hour12: false
                                                                }),
                                                                referral_credited: item.subscription_id ? "Yes" : "No"
                                                            }
                                                        )
                                                    })
                                                }

                                                options={{
                                                    actionsColumnIndex: -1,
                                                    headerStyle: {
                                                        color: '#999998',
                                                        fontWeight: 'bolder',
                                                        fontSize: 15
                                                    },
                                                    filtering: true,
                                                    sorting: true,
                                                    columnsButton: true,
                                                    exportButton: true,
                                                    exportFileName: "Referral Page Data"
                                                }}
                                            />
                                        </ThemeProvider>
                                    ) : (
                                        <div className="text-center pt-2">
                                            <label>Referral Data Not Present</label>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                )
        }
    </>);
}

export default ReferralPage;